import { Box, ButtonGroup } from "@mui/material";
import Download2LineIcon from "remixicon-react/Download2LineIcon";
import Upload2LineIcon from "remixicon-react/Upload2LineIcon";
import { BtnPoper, Button, Text } from "$components";
import useJStyles from "$hooks/useJStyles";
import { theme } from "$utils/theme/bataillog";

function ButtonList() {
  const { jclasses } = useJStyles();

  return (
    <>
      <Text type="h3">Boutons</Text>
      <Text style={{ marginBottom: theme.spacing(2) }}>
        <i>
          {`Composant très fouilli... Le type du composant (contained, outlined ou
        text) et la couleur (primary, secondary) s'interfèrent mutuellement...`}
        </i>
      </Text>
      <Box display="flex" style={{ gap: theme.spacing(2) }}>
        <Button variant="contained">Button contained (défaut)</Button>
        <Button variant="outlined">Button outlined</Button>
        <Button variant="text">Button text</Button>
        <Button variant="contained" confirm>
          Button avec confirmation
        </Button>
        <Button color="primary">{`Button couleur "primary"`}</Button>
        <Button color="secondary">{`Button couleur "secondary"`}</Button>

        <BtnPoper
          BtnLabel="BtnPoper"
          BtnComponent={Button}
          BtnIcon={Download2LineIcon}
        >
          <ButtonGroup
            orientation="vertical"
            size="large"
            aria-label="vertical contained primary button group"
          >
            <Button variant="contained" className={jclasses.jBtnOnPopper}>
              <Upload2LineIcon />
              Option 1
            </Button>
            <Button variant="contained" className={jclasses.jBtnOnPopper}>
              <Upload2LineIcon />
              Option 2
            </Button>
          </ButtonGroup>
        </BtnPoper>
      </Box>
    </>
  );
}

export default ButtonList;
